<template>
  <div class="logo cor-secundaria-bg">
    <img
      class="cor-primaria-border"
      alt="Logo"
      :src="this.$store.state.empresa.empresa_logo"
    />
  </div>
</template>

<script>
export default {
  name: "LogoEmpresa"
};
</script>

<style scoped>
.logo {
  z-index: 10;
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transition: all 0.3s ease 0s;
}
.logo > img {
  height: 130px;
  width: auto;
  border-radius: 10px;
  border-style: solid;
  border-width: 5px;
  margin: 15px;
}

@media screen and (max-height: 640px) {
  .logo > img {
    height: 120px;
    margin: 10px;
    border-width: 4px;
  }
}
@media screen and (max-height: 540px) {
  .logo > img {
    height: 110px;
    margin: 5px;
    border-width: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/LogoEmpresa.vue